import { render, staticRenderFns } from "./ChannelsHero.vue?vue&type=template&id=dda0255c&scoped=true&"
import script from "./ChannelsHero.vue?vue&type=script&lang=js&"
export * from "./ChannelsHero.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsHero.vue?vue&type=style&index=0&id=dda0255c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda0255c",
  null
  
)

export default component.exports